module.exports = __webpack_public_path__ + "static/media/2.aba7b939.png";